import React, { Component } from 'react';
import InputMask from 'react-input-mask';

import './style/style.scss';

import error from './images/error.svg';

export default class Shop extends Component {
	masks = {
		cnpj: '99.999.999/9999-99',
		phone: '(99) 9999-9999',
		cel: '(99) 99999-9999',
		cep: '99999-999',
	};

	formInputs = {
		nome: '',
		cnpj: '',
		cep: '',
		telefone: '',
		endereco: '',
		complemento: '',
		estado: '',
		cidade: '',
	};

	constructor(props) {
		super(props);
		this.state = {
			fieldValue: '{"nome":"","cnpj":"","cep":"","telefone":"","endereco":"","complemento":"","estado":"","cidade":""}',
			formInputs: this.formInputs,
			phoneMask: this.masks.phone,
		};
		this.handleChange = this.handleChange.bind(this);
	}

	componentDidMount() {
		const { valueField } = this.props;
		if (!valueField) {
			return false;
		}
		const values = (typeof valueField === 'string') ? JSON.parse(valueField) : valueField;

		this.setState({
			formInputs: values,
		});

		return this;
	}

	requiredMessageElement = () => (<span className="required">*Preenchimento obrigatório.</span>);

	updateMask = (e) => {
		const firsPhoneDigit = parseInt(e.value.substring(5, 6), 10);
		const mask = (firsPhoneDigit === 9) ? this.masks.cel : this.masks.phone;

		this.setState({
			phoneMask: mask,
		});
	};

	formIsValid() {
		const { formInputs } = this.state;
		const { required } = this.props;
		if (required) {
			return Object.keys(formInputs).every((key) => {
				if (key !== 'complemento') {
					return !!formInputs[key];
				}
				return required;
			});
		}
		return true;
	}

	handleChange(evt) {
		const { fieldValue, formInputs } = this.state;
		const { onGetValueField, nameField } = this.props;

		const value = JSON.parse(Object.assign(fieldValue));

		if (typeof (evt) !== 'undefined') {
			value[evt.target.name] = evt.target.value;
			formInputs[evt.target.name] = evt.target.value;

			if (evt.target.name === 'telefone') {
				this.updateMask(evt.target);
			}

			this.setState({
				fieldValue: JSON.stringify(formInputs),
			});

			onGetValueField(nameField, formInputs, this.formIsValid());
		}
	}

	render() {
		const {
			question,
			messageErrorField,
			classField,
			nameField,
			required,
			filial,
			meta,
			changeFilial,
			removeFilial,
		} = this.props;

		const { formInputs, phoneMask } = this.state;
		const fromControl = 'form-control';

		return (
			<div className="component-shop">
				<div className={`component-group-address ${filial.indexOf(meta.filial) !== -1 ? 'd-block' : 'd-none'}`}>
					<div className="component-question-data">
						<div className="component-title-step subtitle-step my-3">
							<h3>
								{question}
							</h3>

							{meta.filial === 0 ? '' : <img role="presentation" src={error} alt="Ícone de erro" width={37} onClick={removeFilial.bind(this, meta.filial)} onKeyPress={removeFilial.bind(this, meta.filial)} />}
						</div>

						<div className="container-input mb-2">
							<form id={nameField} className="row">
								<div className="col-12 form-group">
									<p>Nome da {question}:
										{required ? this.requiredMessageElement() : ''}
									</p>
									<input
										type="text"
										className={!formInputs.nome ? classField : fromControl}
										name="nome"
										onChange={this.handleChange}
										required={required}
										value={formInputs.nome}
									/>
									<div className="help-block">{!formInputs.nome ? messageErrorField : ''}</div>
								</div>
								<div className="col-12">
									<p>CNPJ da {question}:
										{required ? this.requiredMessageElement() : ''}
									</p>
									<InputMask
										type="text"
										mask={this.masks.cnpj}
										className={!formInputs.cnpj ? classField : fromControl}
										name="cnpj"
										onChange={this.handleChange}
										required={required}
										value={formInputs.cnpj}
									/>
									<div className="help-block">{!formInputs.cnpj ? messageErrorField : ''}</div>
								</div>
								<div className="col-12">
									<p>Telefone do responsavel da {question}:
										{required ? this.requiredMessageElement() : ''}
									</p>
									<InputMask
										type="text"
										mask={phoneMask}
										className={!formInputs.telefone ? classField : fromControl}
										name="telefone"
										required={required}
										onChange={this.handleChange}
										value={formInputs.telefone}
									/>
									<div className="help-block">{!formInputs.telefone ? messageErrorField : ''}</div>
								</div>
								<div className="col-12 mt-4 mb-3">
									<p>
										Endereço da {question}:
										{required ? this.requiredMessageElement() : ''}
									</p>
								</div>
								<div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
									<p><small>Endereço:</small></p>
									<input
										type="text"
										className={!formInputs.endereco ? classField : fromControl}
										name="endereco"
										onChange={this.handleChange}
										required={required}
										value={formInputs.endereco}
									/>
									<div className="help-block">{!formInputs.endereco ? messageErrorField : ''}</div>
								</div>
								<div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
									<p><small>Complemento:</small></p>
									<input
										type="text"
										className="form-control"
										name="complemento"
										onChange={this.handleChange}
										value={formInputs.complemento}
									/>
								</div>
								<div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
									<p><small>Cidade:</small></p>
									<input
										type="text"
										className={!formInputs.cidade ? classField : fromControl}
										name="cidade"
										onChange={this.handleChange}
										required={required}
										value={formInputs.cidade}
									/>
									<div className="help-block">{!formInputs.cidade ? messageErrorField : ''}</div>
								</div>
								<div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
									<p><small>Estado:</small></p>
									<input
										type="text"
										className={!formInputs.estado ? classField : fromControl}
										name="estado"
										onChange={this.handleChange}
										required={required}
										value={formInputs.estado}
									/>
									<div className="help-block">{!formInputs.estado ? messageErrorField : ''}</div>
								</div>
								<div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
									<p><small>CEP:</small></p>
									<InputMask
										type="text"
										mask={this.masks.cep}
										className={!formInputs.cep ? classField : fromControl}
										name="cep"
										onChange={this.handleChange}
										required={required}
										value={formInputs.cep}
									/>
									<div className="help-block">{!formInputs.cep ? messageErrorField : ''}</div>
								</div>
							</form>
						</div>

						<button type="button" className="btn btn-default my-4" onClick={changeFilial.bind(this, meta.filial)}>Adicionar filial</button>
					</div>
				</div>
			</div>
		);
	}
}
